var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('p',[_vm._v("1.请确认输入的手机号是否为您注册的手机号；")]),_c('p',[_vm._v("2.请检查短信是否被手机安全软件拦截；")]),_c('p',[_vm._v("3.由于网络原因，短信可能会延迟；")]),_c('p',[_vm._v("4.若多次未收到短信，请咨询客服。")])])
}]

export { render, staticRenderFns }